var ERouteHttpVerb = /*#__PURE__*/ function(ERouteHttpVerb) {
    ERouteHttpVerb["GET"] = "GET";
    ERouteHttpVerb["POST"] = "POST";
    ERouteHttpVerb["PUT"] = "PUT";
    ERouteHttpVerb["PATCH"] = "PATCH";
    ERouteHttpVerb["DELETE"] = "DELETE";
    return ERouteHttpVerb;
}(ERouteHttpVerb || {});
export { ERouteHttpVerb };
